import { DocumentNode, Kind } from "graphql";
import _ from "lodash";

/** A TDA's `dataLoaderConfig.valueQueryConfig`: resolves selected ids to their labels. */
export interface ValueQueryConfig {
    query: string;
    dataKeyPath: string;
    valueKeyPath: string;
    titleKeyPath: string;
}

/**
 * Whether the value query takes a list of ids (`$id: [ID!]`) and can resolve every
 * selected value in one request, or a single id (`$id: ID!`).
 */
export const acceptsIdList = (document: DocumentNode): boolean => {
    const operation = document.definitions.find((definition) => definition.kind === Kind.OPERATION_DEFINITION);
    if (operation?.kind !== Kind.OPERATION_DEFINITION) return false;
    let type = operation.variableDefinitions?.find((variable) => variable.variable.name.value === "id")?.type;
    if (type?.kind === Kind.NON_NULL_TYPE) type = type.type;
    return type?.kind === Kind.LIST_TYPE;
};

/**
 * Labels by value from a value query result. `dataKeyPath` points at a single object
 * (`client(id: $id)`) or at a list (`clientList(filter: {id: {in: $id}})`) — the same
 * as the library's SearchableMultiSelect resolves them.
 */
export const extractValueLabels = (data: unknown, config: ValueQueryConfig): Record<string, string> => {
    const result = _.get(data, config.dataKeyPath);
    const items: unknown[] = result == null ? [] : Array.isArray(result) ? result : [result];
    const labels: Record<string, string> = {};
    items.forEach((item) => {
        const value = _.get(item, config.valueKeyPath);
        const label = _.get(item, config.titleKeyPath);
        if (value != null && label != null) labels[String(value)] = String(label);
    });
    return labels;
};
